import { Toast } from '@byecode/ui'
import { InputFlowArg } from '@lighthouse/core'
import { generateArgVariableValue } from '@lighthouse/shared'

import * as srv from '@/services'

import { ExecuteActionParams } from '../type'

export const handleAutomation = async (config: InputFlowArg, params: ExecuteActionParams) => {
    const { workflowList } = params
    const { flowId, args } = config
    const flowData = workflowList?.find(w => w.id === flowId)

    if (!flowData) {
        return { type: 'interrupted', success: true }
    }

    // 必须要启用才可以执行
    if (!flowData?.enabled) {
        Toast.error('执行失败，因为工作流未启用')
        return { type: 'interrupted', success: true }
    }

    const triggerArgs = args?.map(arg => {
        return generateArgVariableValue(arg, params)
    })

    // 执行
    const data = await srv.triggerAutomationAction({
        flowId: flowData.id,
        args: triggerArgs
    })
    if (data?.success) {
        return { type: 'args', success: true, data: data.outputArgs }
    } else {
        Toast.error('执行失败')
        return { type: 'interrupted', success: true }
    }
}
